const PanamaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112125)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 20C0 31.0456 8.95437 40 20 40C20 32.3941 20 20 20 20C20 20 6.95648 20 0 20Z"
        fill="#0052B4"
      />
      <path
        d="M20 0C31.0456 0 40 8.95437 40 20C32.3941 20 20 20 20 20C20 20 20 6.95648 20 0Z"
        fill="#D80027"
      />
      <path
        d="M11.9054 6.95703L13.2004 10.9428H17.3913L14.0008 13.4061L15.2958 17.3919L11.9054 14.9285L8.5149 17.3919L9.8099 13.4061L6.41943 10.9428H10.6103L11.9054 6.95703Z"
        fill="#0052B4"
      />
      <path
        d="M28.0943 22.6084L29.3894 26.5942H33.5803L30.1897 29.0575L31.4848 33.0432L28.0943 30.5799L24.7039 33.0432L25.9989 29.0575L22.6084 26.5942H26.7993L28.0943 22.6084Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112125">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PanamaSvg;
